import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { formatDate, DATE_FORMATS, dateToRelativeTrans, parseIsoDateOrTimestamp } from '@wix/da-ds/pkg/Time/functions';
import s from './Timestamp.scss';
const Timestamp = ({ className, timestamp, showTooltip, isShort, isCapitalized, showFullLengthOnMobile })=>{
    const { t, i18n } = useTranslation();
    const isMobile = useContext(MobileContext);
    const isMounted = useIsMounted();
    if (!timestamp) {
        return null;
    }
    const relativeTrans = dateToRelativeTrans(timestamp, isMobile && !showFullLengthOnMobile || isShort);
    const formattedDate = formatDate(timestamp, DATE_FORMATS.DateTime.FullTimeZone, i18n.language);
    return /*#__PURE__*/ React.createElement("time", {
        "aria-label": formattedDate,
        dateTime: parseIsoDateOrTimestamp(timestamp).toISOString(),
        className: classnames(isCapitalized && s['capitalize'], className),
        title: showTooltip && isMounted ? formattedDate : undefined,
        suppressHydrationWarning: true
    }, t(relativeTrans.key, {
        count: relativeTrans.value
    }));
};
Timestamp.displayName = 'Timestamp';
export default /*#__PURE__*/ React.memo(Timestamp);
